<template>
    <div class="section pt-4">
        <div class="container">
            <h2>{{ $t('error.header') }}</h2>
            <h3> {{ $t('error.body') }} </h3>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ErrorComponent'
}
</script>

<style scoped>

</style>
